import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  #app {
    min-height: 100%;
    min-width: 100%;
  }

  .x-hellosign-embedded--in-modal {
    z-index: 999;
  }

  .cameratag_room {
    height: 600px;
  }

  #request-revision-tooltip {
    z-index: 0;
  }

  /* The Cue panel is fixed to the viewport top, so the impersonation banner —
     which is in the page flow — paints over its header and buries "New chat".
     Tailwind's top-0/h-full inside the Cue bundle are single-class selectors
     and load after this sheet, so the override needs !important. */
  .cue-panel-below-impersonation-banner {
    top: var(--impersonation-banner-height, 0px) !important;
    height: calc(100% - var(--impersonation-banner-height, 0px)) !important;
  }

  body #x-gist-floating-bottom-right,
  body #x-gist-floating-bottom {
    z-index: 80;
  }
`;

export default GlobalStyle;
